export const help: object = {
  help: {
    getHelp: 'Get Help',
    contactUs: 'Contact Us',
  }
};
